<ng-container *ngIf="title || body">
  <dgx-components-panel
    [border]="false"
    [rounded]="'lg'"
    [title]="title"
    [variant]="theme"
  >
    <dgx-components-rich-text *ngIf="body" [content]="body" />
  </dgx-components-panel>
</ng-container>
